
import * as React from 'react';
import { IWithWizardInjectedProps } from '../../decorators/withWizard';
import { Panel } from 'office-ui-fabric-react/lib/Panel';
import { progressRootItemKey, expireProgressItems, getOverallProgressPhase } from '../../../operations/progress';
import ProgressStrings from '../ProgressStrings.resx';
import { ProgressList } from '../list/ProgressList';
import { WithItemCache, IItemCacheStateProps } from '../../withItemCache/WithItemCache';
import { makeObject } from '../../../utilities/objects';
import { childItemsFacet } from '../../../facets/SetFacets';
import { ProgressPhase } from '../../../facets/ProgressFacets';

/**
 * @public
 */
export interface IProgressPanelProps extends IWithWizardInjectedProps {
    // Nothing added.
}

const NO_GROUPS: string[] = [];

/**
 * Component which renders a panel around a ProgressList, keeping the progress
 * items from expiring while shown.
 * @public
 */
export class ProgressPanel extends React.PureComponent<IProgressPanelProps> {
    public render(): JSX.Element {
        return (
            <WithItemCache>{ ({ itemCache, dispatch }: IItemCacheStateProps) => {
                const childGroupItems = itemCache.demandItemFacet(childItemsFacet, progressRootItemKey);
                const groupItemKeys = childGroupItems && childGroupItems.itemKeys || NO_GROUPS;

                const itemKeysToExpire = groupItemKeys.filter((itemKey: string) => {
                    const progressPhase = getOverallProgressPhase(itemCache, { itemKey });

                    return progressPhase === ProgressPhase.completed || progressPhase === ProgressPhase.canceled;
                });

                const onDismissed = () => {
                    dispatch(expireProgressItems({
                        items: makeObject(itemKeysToExpire, () => true)
                    }));

                    this.props.resolve();
                };

                return (
                    <Panel
                        isOpen={ true }
                        headerText={ ProgressStrings.progressTitle }
                        isLightDismiss={ true }
                        onDismissed={ onDismissed }
                    >
                        <ProgressList itemKeys={ groupItemKeys } />
                    </Panel>
                );
            } }</WithItemCache>
        );
    }
}
